import React, { useCallback, useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Actions from 'actions'
import DazzedHeading20 from 'components/common/text/DazzedHeading20'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import PrimaryButton from 'components/common/buttons/PrimaryButton'
import Step1Download from 'components/common/icons/bulk-invite/step1-download'
import Step2Upload from 'components/common/icons/bulk-invite/step2-upload'
import { trackEvent } from 'utils/analyticsUtils'
import BulkCreatePatientsDialog from './BulkCreatePatientsDialog'

const useStyles = makeStyles({
  stepsList: {
    padding: '8px 8px!important'
  },
  bold: {
    fontWeight: 600
  },
  center: {
    textAlign: 'center'
  },
  downloadIcon: {
    marginTop: 12
  },
  uploadButtonContainer: {
    padding: '16px 0'
  }
})

const BulkCreatePatients = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const templateDownloadUrl = useMemo(
    () => `data:text/csv;charset=utf-8,${encodeURIComponent('First Name,Last Name,Date of Birth,Notes\n')}`,
    []
  )

  const handleOpenUploadForm = useCallback(() => {
    dispatch(Actions.toggleBulkCreatePatientsPopup({ isOpen: true }))
  }, [dispatch])

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <DazzedHeading20>{t('pages.accountSettings.advancedActions.bulkCreatePatients.title')}</DazzedHeading20>
      </Grid>
      <Grid item>
        <DazzedParagraph14 strong>
          {t('pages.accountSettings.advancedActions.bulkCreatePatients.description')}
        </DazzedParagraph14>
      </Grid>
      <Grid item className={classes.stepsList}>
        <Grid container spacing={1}>
          <Grid item>
            <Grid container alignItems="center" direction="row">
              <Grid item xs={2}>
                <div className={[classes.center, classes.downloadIcon].join(' ')}>
                  <Step1Download />
                </div>
              </Grid>
              <Grid item xs={10}>
                <DazzedParagraph14 strong>
                  <span className={classes.bold}>1. </span>
                  <a
                    href={templateDownloadUrl}
                    download="bulk-create-patients-template.csv"
                    onClick={() => trackEvent('bulk create patients - download csv click')}
                  >
                    {t('pages.accountSettings.advancedActions.bulkCreatePatients.steps.download_1')}
                  </a>
                  {t('pages.accountSettings.advancedActions.bulkCreatePatients.steps.download_2')}
                </DazzedParagraph14>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container alignItems="center" direction="row">
              <Grid item xs={2}>
                <div className={classes.center}>
                  <Step2Upload />
                </div>
              </Grid>
              <Grid item xs={10}>
                <DazzedParagraph14 strong>
                  <span className={classes.bold}>2. </span>
                  {t('pages.accountSettings.advancedActions.bulkCreatePatients.steps.validate')}
                </DazzedParagraph14>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <div className={classes.uploadButtonContainer}>
          <PrimaryButton
            label={t('pages.accountSettings.advancedActions.bulkCreatePatients.validateButton')}
            onClick={handleOpenUploadForm}
          />
        </div>
      </Grid>
      <BulkCreatePatientsDialog />
    </Grid>
  )
}

export default BulkCreatePatients
